import React, { useMemo } from 'react';
import { AuthContext } from './useAuthContext';

export type AuthProviderProps = {
  value: boolean;
  setValue: React.Dispatch<React.SetStateAction<boolean>>;
};

export function AuthProvider({
  value: isAuthenticated,
  setValue: setIsAuthenticated,
  children,
}: React.PropsWithChildren<AuthProviderProps>) {
  const state = useMemo(() => ({
    isAuthenticated,
    setIsAuthenticated,
  }), [isAuthenticated, setIsAuthenticated]);

  return (
    <AuthContext.Provider
      value={state}
    >
      {children}
    </AuthContext.Provider>
  );
}
